export interface File {
    base64content: string;
    type: string;
}